// Live miniature of the report cover for the Branding Manager.
export function CoverPreview({ logo, companyName = "SYMIN", template = "navy" }) {
  const navy = "#1F2937";
  const orange = "#C20511";
  const dark = template === "navy";
  const bg = dark ? navy : "#ffffff";
  const titleColor = dark ? "#ffffff" : navy;
  const subColor = dark ? "#C7D2E0" : "#5B6675";
  const boxBg = dark ? "#24384F" : "#F1F5F9";

  return (
    <div
      className="w-full max-w-[260px] mx-auto rounded-md overflow-hidden shadow-sm border border-slate-200 flex flex-col"
      style={{ aspectRatio: "1 / 1.414", background: bg }}
      data-testid="cover-preview-mock"
    >
      <div style={{ height: 6, background: orange, flexShrink: 0 }} />
      <div className="flex-1 flex flex-col items-center justify-center text-center px-4 py-3">
        {logo ? (
          <img src={logo} alt="logo" className="max-h-10 max-w-[130px] object-contain mb-3" />
        ) : (
          <div className="mb-3">
            <div className="font-extrabold text-lg leading-none" style={{ color: titleColor }}>SYMIN</div>
          </div>
        )}
        <div className="text-[7px] font-bold tracking-widest" style={{ color: orange }}>REMOTE SENSING &amp; EXPLORATION</div>
        <div className="text-[6px] mt-0.5 tracking-widest" style={{ color: subColor }}>MASTER REPORT</div>
        <div className="text-[12px] font-bold mt-2 leading-tight" style={{ color: titleColor }}>CLIENT NAME LIMITED</div>
        {template === "minimal" ? (
          <>
            <div style={{ height: 2, width: 56, background: orange, margin: "8px auto" }} />
            <div className="text-[7px]" style={{ color: subColor }}>PN-001 • Country • Gold • 2026</div>
          </>
        ) : (
          <div className="grid grid-cols-2 gap-1 mt-3 w-full">
            {["PROJECT", "CLIENT", "AREAS", "TARGETS"].map((l) => (
              <div
                key={l}
                className="rounded-sm px-1.5 py-1 text-left"
                style={{ background: boxBg, border: dark ? "none" : "1px solid #E2E8F0" }}
              >
                <div className="text-[6px] font-bold" style={{ color: orange }}>{l}</div>
                <div className="text-[8px] font-bold" style={{ color: dark ? "#fff" : navy }}>-</div>
              </div>
            ))}
          </div>
        )}
      </div>
      <div
        className="flex items-center px-3"
        style={{ height: 20, background: bg, borderTop: `2px solid ${orange}`, flexShrink: 0 }}
      >
        <span className="text-[7px] truncate" style={{ color: dark ? "#fff" : navy }}>
          Prepared by {companyName || "SYMIN"}
        </span>
      </div>
    </div>
  );
}
